export var formatPhoneNumber = function formatPhoneNumber(x) {
  try {
    x = x ? x : "";
    x = typeof x === "number" ? x.toString() : x;
    var arr = x.split("");

    if (arr.length === 11) {
      for (var i in arr) {
        if (i === "0") arr[i] = "+".concat(arr[i], " ");
        if (i === "3") arr[i] = "".concat(arr[i], " ");
        if (i === "6") arr[i] = "".concat(arr[i], "-");
      }

      return arr.join("");
    }

    return x;
  } catch (err) {
    console.error(err);
  }
};